module.exports = __webpack_public_path__ + "static/img/fei.bd6738b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fei.jpg
// module id = lkIL
// module chunks = 1